import {IOriginWrapper} from "~/interfaces/mappingInterfaces";
import {IDefaultVOption} from "~/interfaces/vSelectInterfaces";
import ObjectModel from "~/models/objectModel";
import {ModelType} from "~/enums/modelType";

export default class OriginWrapperObjectModel implements IOriginWrapper<ObjectModel> {
  readonly type = ModelType.ObjectModel

  constructor(private objectModel: ObjectModel) {
  }

  get object(): ObjectModel {
    return this.objectModel
  }

  get client_id(): string {
    return this.objectModel.client_id
  }

  get rootIdentifier(): string {
    return this.objectModel.client_id
  }

  get value(): IDefaultVOption {
    return {label: this.objectModel.titleOrDefault, value: this.objectModel.client_id}
  }
}